import { Stack, type StackProps } from '@mui/material';
import { FORM_FIELD_GAP } from './formLayout';

/** Vertical stack with consistent spacing for all forms */
export default function FormStack({ spacing = FORM_FIELD_GAP, ...props }: StackProps) {
  return <Stack spacing={spacing} {...props} />;
}
